import { useErrorTest } from 'app/components/error-test/useErrorTest'
import { ErrorTestComponent } from 'app/components/error-test/ErrorTestComponent'

export default function ErrorTest() {
  const { data } = useErrorTest()
  return <ErrorTestComponent data={data} />
}
